import vars from "../../config/variables.module.scss";

export const busyItems2 = [
  {
    isChecked: true,
    text: "Новый специалист",
    value: "Нов",
    color: vars.filterBusyNewcomer,
    colorUnchecked: vars.filterBusyNewcomerUnchecked,
  },
  {
    isChecked: true,
    text: "Свободен",
    value: [0, 20],
    color: vars.filterBusyFree,
    colorUnchecked: vars.filterBusyFreeUnchecked,
  },
  {
    isChecked: true,
    text: "Средняя загрузка",
    value: [21, 40],
    color: vars.filterBusyAverage,
    colorUnchecked: vars.filterBusyAverageUnchecked,
  },
  {
    isChecked: true,
    text: "Сильная загрузка",
    value: [41, 70],
    color: vars.filterBusyHigh,
    colorUnchecked: vars.filterBusyHighUnchecked,
  },
  {
    isChecked: true,
    text: "Занят",
    value: [71, 100],
    color: vars.filterBusyFull,
    colorUnchecked: vars.filterBusyFullUnchecked,
  },
];
